import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import{LoopBackAuth, validacionService, docenteService, asignaturaService} from '../../services/api-rest.service';
import{MessageService} from '../../services/message.service';
import { ModalAsignarActividadesComponent } from '../../modal/modal-asignar-actividades/modal-asignar-actividades.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'form-asignar-pensum',
  templateUrl: './form-asignar-pensum.component.html',
  styles: [],
  providers:[LoopBackAuth, validacionService,docenteService, asignaturaService, MessageService, ]
})
export class FormAsignarPensumComponent implements OnInit {
  @Input() formAsignarPensum: FormGroup
  asignaturas: any
  docentes: any
  ordenes: any 
  
  constructor(
    private docenteService:docenteService,
    private asignaturaService: asignaturaService,
    private val:validacionService,
    private modalService: NgbModal,
  ) { }

  ngOnInit() {
    this.onGetOrden()
    this.asignaturaService.listaActivas().subscribe(lista => {
      this.asignaturas = []
      for(let item of lista){
        this.asignaturas.push({label:item.descripcion, value:item.id.toString()})
      }
    })
    this.docenteService.search().subscribe(lista => {
      this.docentes =[]
      for(let item of lista){
        this.docentes.push({label:"["+item.glbUsuario.identificacion+"] "+item.glbUsuario.apellido +" "+ item.glbUsuario.nombre , value:item.id.toString()})
      }
    })
  }
  
  onGetOrden(){
    this.ordenes = []
    for(let i = 1; i <= 100; i++){
      this.ordenes.push({
        id: i,
        descripcion: i
      })
      
    }
  }

  modalAsignarActividades(){
    const ventana = this.modalService.open(ModalAsignarActividadesComponent,{
      size:'sm'
    })
    ventana.componentInstance.activos = this.formAsignarPensum.get('actividad').value
    ventana.result.then(
    (result) => {
        this.formAsignarPensum.patchValue({
          actividad: result
        })
    });
  }
  
  
}



// WEBPACK FOOTER //
// ./src/app/shared/element/formularios/form-asignar-pensum.component.ts